import types from '../utils/types'

export const isPhotoActionAllowed = (me, photographerId, checkRole) => {
  if (!me) return 0
  else if (me.id === photographerId) return 1
  else if (
    [types.user.role.user, types.user.role.scholar].includes(me.role) &&
    checkRole
  )
    return 2
  else return false
}

export const likePhotoErrorMessages = index => {
  const messages = [
    'You need to log in to like this photo',
    'You cannot like your own photos',
    'Only users ranked Student or higher can Super Like photos'
  ]
  return messages[index]
}

export const actionTypesDescription = (type, performed) => {
  if (type === 'comment_vote_up')
    if (performed) return 'You liked a comment'
    else return 'Someone liked your comment'
  else if (type === 'comment_vote_down')
    if (performed) return 'You voted down on a comment'
    else return 'Someone voted down on your comment'
  else if (type === 'like_photo')
    if (performed) return 'You liked a photo'
    else return 'Someone liked your photo'
  else if (type === 'dislike_photo')
    if (performed) return 'You disliked a photo'
    else return 'Someone disliked your photo'
  else if (type === 'super_like')
    if (performed) return 'You super liked a photo'
    else return 'Someone super liked your photo'
  else if (type === 'publish_photo' || type === 'reject_photo')
    return 'You reviewed a photo'
  else if (type === 'publish_photo_by_task')
    return 'Your photo has been published'
  else if (type === 'photo_deleted_by_moderator')
    return 'You removed someone else photo'
  else if (type === 'upload_photo')
    if (performed) return 'You uploaded a photo'
    else return ''
  else if (type === 'write_a_comment')
    if (performed) return 'You wrote a comment on a photo'
    else return 'Someone commented on your photo'
  else if (type === 'comment_removed')
    if (performed) return 'You removed a comment'
    else return 'Someone removed your comment'
  else if (type === 'share_photo_on_facebook')
    if (performed) return 'You shared a photo on Facebook'
    else return 'Someone shared your photo on Facebook'
  else if (type === 'share_photo_on_instagram')
    if (performed) return 'You shared a photo on Instagram'
    else return 'Someone shared your photo on Instagram'
  else if (type === 'comment_vote_up_reset')
    if (performed) return 'You removed your up vote on a comment'
    else return 'Someone removed its up vote on your comment'
  else if (type === 'comment_vote_down_reset')
    if (performed) return 'You removed your down vote on a comment'
    else return 'Someone removed its down vote on your comment'
  else if (type === 'like_composition')
    if (performed) return 'You voted for composition on a photo'
    else return 'Someone voted for composition on a photo'
  else if (type === 'like_creativity')
    if (performed) return 'You voted for creativity on a photo'
    else return 'Someone voted for creativity on a photo'
  else if (type === 'like_technical')
    if (performed) return 'You voted for technique on a photo'
    else return 'Someone voted for technique on a photo'
  else if (type === 'like_content')
    if (performed) return 'You voted for content on a photo'
    else return 'Someone voted for content on a photo'
  else if (type === 'vote_to_promote')
    if (performed) return 'You voted to promote a photo'
    else return 'Someone voted to promote your photo'
  else if (type === 'user-curate') {
    if (performed) return 'You curated a photo'
    else return 'Someone curated one of your photos'
  }
}
